import React, { useMemo } from 'react'
import { Field } from 'redux-form'
import { useTranslation } from 'react-i18next'

import {
  StyledWrapper,
  StyledSubheadingWrap,
} from '../../order-form.component.styles'
import { TextArea } from 'ggx-src/van-booking/order/sidebar/order-form/additional-requirements/notes-to-driver-form/text-area.component'
import { charLimit250Field } from '../../validation'
import { BodyBold } from 'ggx-componentlibrary/design/typography/typography.styles'
import { StyledSmallText } from 'ggx-src/van-booking/order/sidebar/order-form/additional-requirements/merchant-order-note-form/merchant-order-note-form.component.styles.js'

const Remarks = () => {
  const [t] = useTranslation()
  const characterLimit250Validator = useMemo(
    () => charLimit250Field(t('error.characterLimit250')),
    [t]
  )
  const templates = useMemo(
    () => [
      [t('remark_tmpl_fragile'), t('remark_tmpl_fragile_content')],
      [
        t('remark_tmpl_before_you_arrive_call'),
        t('remark_tmpl_before_you_arrive_call_content'),
      ],
      [t('remark_tmpl_lunch_hours'), t('remark_tmpl_lunch_hours_content')],
      [t('remark_tmpl_delivery_time'), t('remark_tmpl_delivery_time_content')],
    ],
    [t]
  )

  return (
    <StyledWrapper>
      <StyledSubheadingWrap>
        <BodyBold typographyStyles="mb-none">{t('common__remarks')}</BodyBold>
        <StyledSmallText>{t('optional')}</StyledSmallText>
      </StyledSubheadingWrap>

      <Field
        name="remark"
        placeholder={t('orders.new.basicInfo.placeholder.packageRemarks')}
        component={TextArea}
        validate={characterLimit250Validator}
        maxLength="250"
        minRows="3"
        templates={templates}
      />
    </StyledWrapper>
  )
}

export { Remarks }
